import { take, fork } from 'redux-saga/effects';
import { request } from 'utils/action';
import * as apis from 'common/apis';
import * as actions from 'actions/report';

// 获取练习
export const watchGetReport = function* watchGetReport() {
  for (;;) {
    const { payload } = yield take(actions.getReport);
    // 需要根据mode判断 是基础题库的报告页 还是测评系统的报告页
    let newApis;
    if ((payload.payload.type === 1 && payload.payload.examId === 56)
    || payload.payload.type === 2) {
      // 如果是 完整版国高入学测评
      newApis = apis.getTest;
    } else if (payload.payload.mode === 'test' || payload.payload.mode === 'full-test') {
      newApis = apis.getReport.map((item, index) => {
        if (index === 1) {
          return item.replace(/@mode/, payload.payload.mode);
        }
        return item;
      });
    } else {
      newApis = apis.getPracticeNew;
    }
    yield fork(
      request,
      actions.realGetReport,
      newApis,
      payload,
    );
  }
};



// WEBPACK FOOTER //
// ./src/sagas/report.js